module.exports = __webpack_public_path__ + "img/Italgas_Logo.ef538cb4.svg";